import AbstractLayerManager from './AbstractLayerManager';
import Request from '../../Request';

export default class LSRLayerManager extends AbstractLayerManager {
	constructor(myKey, instance) {
		super(myKey, instance);
		this.name = "Local Storm Reports";
		this.popupName = "Local Storm Report";
		this.options.hasPanRefresh = false;
		this.options.hasAutoRefresh = true;
		this.lsr = {};
		this.dataOptions = {};

		this.filters = {
		};
	}
	
	refreshLayer() {
		this.requestLSR();
	}
	
	requestLSR() {
		if(typeof this.dataOptions.queryType === 'undefined') this.dataOptions.queryType = 'all';
		if(this.tasks.fetchLSR === undefined) this.tasks.fetchLSR = new Request({
			url: 'https://api.weatherusa.net/v1/feed/lsr',
			link: 'cancel',
			timeout: 30000,
			onSuccess: this.handleResp.bind(this),
			onError: this.handleError.bind(this)
		});

		this.tasks.fetchLSR.get({
			filters: this.filters
		});
	}

	handleError(err) {
		console.error(err);
	}
	
	handleResp(resp) {
		if(!this.layer) {
			console.error('Could not find layer for layer ID: ' + this.id);
			return false;
		}
		
		let list = resp.body;
		// Remove all paths from LayerGroup
		this.layer.clearLayers();
		this.lsr = {};

		for(const [id,data] of Object.entries(list)){
			var iconBase = 'other.png';
			if(data.event.search(/avalanche/i) != -1) {
				iconBase = 'avalanche.gif';
			}
			else if(data.event.search(/blizzard/i) != -1) {
				iconBase = 'blizzard.png';
			}
			else if(data.event.search(/\bcold|wind chill/i) != -1) {
				iconBase = 'cold.png';
			}
			else if(data.event.search(/downburst/i) != -1) {
				iconBase = 'downburst.png';
			}
			else if(data.event.search(/drought/i) != -1) {
				iconBase = 'drought.png';
			}
			else if(data.event.search(/flood/i) != -1) {
				iconBase = 'flood.png';
			}
			else if(data.event.search(/\bfog/i) != -1) {
				iconBase = 'fog.png';
			}
			else if(data.event.search(/freezing|\bice/i) != -1) {
				iconBase = 'ice.png';
			}
			else if(data.event.search(/funnel cloud/i) != -1) {
				iconBase = 'funnelcloud.png';
			}
			else if(data.event.search(/hail/i) != -1) {
				iconBase = 'hail.png';
			}
			else if(data.event.search(/\bheat/i) != -1) {
				iconBase = 'hot.png';
			}
			else if(data.event.search(/heavy rain/i) != -1) {
				iconBase = 'heavyrain.png';
			}
			else if(data.event.search(/lightning/i) != -1) {
				iconBase = 'lightning.gif';
			}
			else if(data.event.search(/snow/i) != -1) {
				iconBase = 'snow.png';
			}
			else if(data.event.search(/sleet/i) != -1) {
				iconBase = 'sleet.png';
			}
			else if(data.event.search(/tornado/i) != -1) {
				iconBase = 'tornado.png';
			}
			else if(data.event.search(/wi?nd dmg/i) != -1) {
				// This before generic wind, so we match on "dmg" first
				iconBase = 'winddamage.png';
			}
			else if(data.event.search(/\bwi?nd/i) != -1) {
				iconBase = 'wind.png';
			}
			else if(data.event.search(/water\s?spout/i) != -1) {
				iconBase = 'waterspout.png';
			}
			else if(data.event.search(/fire/i) != -1) {
				iconBase = 'fire.png';
			}
			else if(data.event.search(/hurricane|tropical/i) != -1) {
				iconBase = 'tropicalstorm.gif';
			}
			
			var localIcon = new L.Icon({
				iconUrl: '/assets/icons/lsr/' + iconBase,
				iconSize: [32, 32],
				iconAnchor: [16, 32]
			});
			
			var magMeasured = '';
			if(data.magnitude_meas == 'M') {
				magMeasured = '<br />(measured)';
			} else if(data.magnitude_meas == 'E') {
				magMeasured = '<br />(estimated)';
			}
			
			var popStr = '<div class="lsr-event"><img src="/assets/icons/lsr/' + iconBase + '" height="25" />&nbsp;' + data.event + '</div>' +
			'<div class="row no-gutters">' + 
			'<div class="data-box col"><div class="data-label">Magnitude</div><div class="data-value">' + (data.magnitude.length ? (data.magnitude + magMeasured) : '(none)') + '</div></div>' +
			'<div class="data-box col"><div class="data-label">Time</div><div class="data-value">' + data.date + '</div></div>' +
			'</div><div class="row no-gutters">' +
			'<div class="data-box col"><div class="data-label">Location</div><div class="data-value">' + data.city + ', ' + data.state + '</div></div>' +
			'<div class="data-box col"><div class="data-label">Source</div><div class="data-value">' + data.source + '</div></div>' +
			'</div><div class="row no-gutters">' +
			'<div class="data-box col"><div class="data-label">NWS Office</div><div class="data-value">' + data.issuing_office + '</div></div>' +
			'<div class="data-box col"><div class="data-label">Coordinates</div><div class="data-value">' + data.lat + ', ' + data.lon + '</div></div>' +
			'</div>';
			if(data.remarks.length > 0) popStr = popStr + '<div class="row no-gutters"><div class="col"><div class="data-label">Remarks</div><p class="lsr-remarks">' + data.remarks + '</p></div></div>';
			
			this.lsr[data.id] = L.marker(new L.LatLng(data.lat, data.lon), {
				icon: localIcon,
				title: data.event + (data.magnitude.length ? ': ' + data.magnitude : '')
			})
			.on('click', this.handleClick, this)
			.addTo(this.layer);
			this.lsr[data.id].details = popStr;
		}
	}

	handleClick(e) {
		this.inst.forwardedClickHandler(this.id, e, e.target.details);
	}

	getLayerPopupContent(layer) {
		return layer.details;
	}
}
